import ScrollAnimation from "./ScrollAnimation";

// Lightweight wrapper so pages can opt into scroll reveals without importing
// the full ScrollAnimation variant map every time.
const RevealOnScroll = ({
  children,
  animation = "fadeUp",
  className = "",
  threshold = 0.15,
  margin = "-80px",
}) => (
  <ScrollAnimation animation={animation} threshold={threshold} margin={margin}>
    <div className={className}>{children}</div>
  </ScrollAnimation>
);

export default RevealOnScroll;
